/* eslint-disable react/prop-types */
import { AlertTriangle, LoaderCircle, LockKeyhole, ServerCog } from 'lucide-react'
import { Link } from 'react-router-dom'

const STATES = {
  loading: { Icon: LoaderCircle, title: '관리자 세션 확인 중', description: '권한 정보를 안전하게 확인하고 있습니다.' },
  configuration: { Icon: ServerCog, title: 'Firebase 공개 설정 오류', description: '관리자 Firebase 공개 클라이언트 설정을 확인하세요.' },
  forbidden: { Icon: LockKeyhole, title: '접근 권한이 없습니다', description: '이 계정에는 admin custom claim이 없습니다.' },
  error: { Icon: AlertTriangle, title: '권한 확인 실패', description: '네트워크 연결과 Firebase 설정을 확인한 뒤 다시 로그인하세요.' },
  'not-found': { Icon: AlertTriangle, title: '화면을 찾을 수 없습니다', description: '주소가 변경되었거나 존재하지 않는 관리자 화면입니다.' },
}

export default function AccessState({ kind, detail, onAction }) {
  const item = STATES[kind] ?? STATES.error
  const { Icon } = item
  return (
    <main className="access-state">
      <div className={`access-icon ${kind === 'loading' ? 'is-spinning' : ''}`}><Icon size={28} /></div>
      <p className="eyebrow">SU-GUIDE ADMIN</p>
      <h1>{item.title}</h1>
      <p>{item.description}</p>
      {detail && <code className="access-detail">{detail}</code>}
      {onAction && <button className="button secondary" type="button" onClick={onAction}>다른 계정으로 로그인</button>}
      {kind === 'not-found' && <Link className="button primary" to="/dashboard">대시보드로 이동</Link>}
    </main>
  )
}
